/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LoadingSpinner from '$app/shared/components/LoadingSpinner';
import { api } from '$app/api';
import GaragesAllocation from '.';
import { getBookingsToAllocateToGarages } from './apis/bookings';

const GaragesAllocationWrapper = () => {
  const [garages, setGarages] = useState([]);
  const [bookings, setBookings] = useState(null);

  const getAllGarages = () => api.get(`/garages`);

  useEffect(() => {
    getAllGarages().then(({ data }) => {
      setGarages(data.garages);
    });
  }, []);

  const earliestBookingDate = moment().subtract(7, 'day').startOf('day').format();
  useEffect(() => {
    getBookingsToAllocateToGarages(earliestBookingDate).then(setBookings).catch(console.error);
  }, [earliestBookingDate]);

  if (!garages || !bookings) return <LoadingSpinner />;
  return (
    <GaragesAllocation garages={garages} bookings={bookings} earliestBookingDate={earliestBookingDate} />
  );
};

export default GaragesAllocationWrapper;
